<template>
  <div>
    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="editedItem"
        :title="
          $t('components.plan_builder.unionslocals.delete_union_{0}', [
            translate2(editedItem, 'Name'),
          ])
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="editDialog" persistent max-width="1200px">
      <material-card
        v-if="editedItem !== null && editedItem !== undefined"
        :title="formTitle"
        :icon="formIcon"
        :color="formColor"
      >
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col xs="12" sm="6" md="4" lg="4">
                  <!-- <trans-textbox
                    v-model="editedItem"
                    :label="$t('globals.name')"
                    :rules="[$rules.required]"
                    :disabled="disabled"
                    field="Name"
                    class="required"
                  ></trans-textbox> -->
                  <no-autocomplete-textfield
                    v-model="editedItem.Name"
                    :label="$t('globals.name')"
                    :rules="[$rules.required]"
                    class="required"
                    :disabled="disabled"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="4">
                  <no-autocomplete-textfield
                    v-model="editedItem.TradeCode"
                    :label="$t('headers.unions.trade_code')"
                    :rules="[$rules.integer, $rules.dynamic.length(1)]"
                  ></no-autocomplete-textfield>
                </v-col>
              </v-row>
            </v-form>
            <v-row v-if="valid">
              <v-col cols="12">
                <locals-table
                  :locals="editedItem.Locals"
                  @locals-changed="editedItem.Locals = $event"
                  :disabled="disabled"
                  :planIdentityId="planIdentityId"
                  :union="editedItem"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!valid || editedItem.Locals.length === 0"
            color="primary"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="addLocalDialog" persistent max-width="1200px">
      <material-card
        v-if="local !== null && local !== undefined"
        :title="
          $t('components.plan_builder.localstable.create_new_local_{0}', [
            editedItem.Name,
          ])
        "
        icon="add"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <locals-form
            ref="localform"
            @valid-changed="valid = $event"
            :item="local"
            :disabled="disabled"
            :planIdentityId="planIdentityId"
            :union="editedItem"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeLocal">{{ $t("globals.cancel") }}</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="saveLocal">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.import" persistent max-width="1000px">
      <unions-import-wizard
        v-if="dialogs.import"
        @close="dialogs.import = false"
        @unions="importUnions"
      />
    </v-dialog>
    <material-card
    :title="$t('components.plancreationwizard.unions_locals')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="mdi-set-all"
    >
      <pbas-data-table
        ref="table"
        :showSelect="false"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="unions"
        @itemsChanged="setData($event)"
        :identifier="'unions_plan_builder'"
        @error="error = $event"
      ></pbas-data-table>
      <v-snackbar v-model="snackbar" color="success" :timeout="2500">
        {{ $t("globals.success") }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import InMemoryUnionsHeaders from "@/headers/InMemoryUnions";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { translate2 } from "../../trans2";
import LocalsTable from "@/components/PlanBuilder/LocalsTable.vue";
import TransTextbox from "../TransTextbox.vue";
import LocalsForm from "./LocalsForm.vue";
import UnionsImportWizard from "@/components/PlanBuilder/UnionsImportWizard.vue";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    LocalsTable,
    TransTextbox,
    LocalsForm,
    UnionsImportWizard,
  },
  props: ["unions", "planIdentityId", "disabled"],
  data() {
    return {
      error: null,
      items: [],
      deleteDialog: false,
      provider: undefined,
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            let item = {
              Identifier: Math.random().toString(),
              Locals: [],
            };
            this.isNew = true;
            this.editItem(item);
          },
          visible: () => !this.disabled,
        },
        {
          text: "globals.bulk_import",
          color: this.$vuetify.theme.themes.light.primary,
          name: "import",
          icon: "add",
          handler: () => {
            this.dialogs.import = true;
          },
          visible: () => !this.disabled,
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.isNew = false;
            this.editItem(item);
          },
          visible: () => !this.disabled,
        },
        {
          name: "addLocal",
          icon: "add",
          title: "components.plan_builder.unionslocals.add_local",
          handler: (item) => {
            this.editedItem = item;
            this.local = {
              Identifier: Math.random().toString(),
              Contacts: [],
              Address: {},
            };
            this.addLocalDialog = true;
          },
          visible: () => !this.disabled,
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.editedItem = item;
            this.deleteDialog = true;
          },
          visible: () => !this.disabled,
        },
      ],
      snackbar: false,
      editDialog: false,
      valid: true,
      editedItem: null,
      isNew: false,
      addLocalDialog: false,
      local: null,
      dialogs: {
        import: false,
      },
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    formTitle() {
      return this.isNew
        ? this.$t("components.plan_builder.unionslocals.create_new_union")
        : this.$t("components.plan_builder.unionslocals.edit_union_{0}", [
            translate2(this.editedItem, "Name"),
          ]);
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    unions: {
      handler(v) {
        if (v) {
          if (this.provider) {
            this.provider.items = v;
            this.$refs.table.getDataAsync();
          }
        }
      },
    },
  },
  mounted() {
    this.provider = new InMemoryProvider(this.unions, InMemoryUnionsHeaders);
  },
  methods: {
    importUnions(unions) {
      this.provider.items = unions;
      this.$refs.table.getDataAsync();
      this.dialogs.import = false;
      this.$emit("unions-changed", this.provider.items);
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
    setData(items) {
      this.items = items;
    },
    validate() {
      if (this.$refs.form && this.$refs.form.validate()) {
        return true;
      }
      return false;
    },
    async editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editDialog = true;
    },
    close() {
      this.editedItem = null;
      this.$refs.form.resetValidation();
      this.editDialog = false;
    },
    save() {
      this.editedItem.PlanIdentityId = this.planIdentityId;
      if (this.isNew) {
        this.add();
      } else {
        this.update(true);
      }
    },
    async update(close) {
      const con = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(con);
      this.provider.items[index] = JSON.parse(JSON.stringify(this.editedItem));
      if (close) {
        this.close();
      }
      this.$refs.table.getDataAsync();
      this.$emit("unions-changed", this.provider.items);
    },
    async add() {
      this.provider.items.push(JSON.parse(JSON.stringify(this.editedItem)));
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit("unions-changed", this.provider.items);
    },
    async tryDelete() {
      const con = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(con);
      this.provider.items.splice(index, 1);
      this.deleteDialog = false;
      this.$refs.table.getDataAsync();
      this.$emit("unions-changed", this.provider.items);
    },
    saveLocal() {
      this.local.Name = this.local.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      if (Object.keys(this.local.Address).length === 0) {
        delete this.local.Address;
      }
      this.editedItem.Locals.push(this.local);
      this.update();
      this.local = null;
      this.addLocalDialog = false;
      this.snackbar = true;
    },
    closeLocal() {
      this.addLocalDialog = false;
      this.editedItem = null;
      this.local = null;
      this.$refs.localform.resetValidation();
    },
  },
};
</script>
